// extracted by mini-css-extract-plugin
export var light = "textLink-module--light--5dbe6";
export var textLink = "textLink-module--textLink--2415d";